const gradient = require("webskit-gradient-parser");

export function hexToHSL(H) {
  // Convert hex to RGB first
  let r = 0,
    g = 0,
    b = 0;
  if (H.length === 4) {
    r = "0x" + H[1] + H[1];
    g = "0x" + H[2] + H[2];
    b = "0x" + H[3] + H[3];
  } else if (H.length === 7) {
    r = "0x" + H[1] + H[2];
    g = "0x" + H[3] + H[4];
    b = "0x" + H[5] + H[6];
  }
  // Then to HSL
  r /= 255;
  g /= 255;
  b /= 255;
  let cmin = Math.min(r, g, b),
    cmax = Math.max(r, g, b),
    delta = cmax - cmin,
    h = 0,
    s = 0,
    l = 0;

  if (delta === 0) h = 0;
  else if (cmax === r) h = ((g - b) / delta) % 6;
  else if (cmax === g) h = (b - r) / delta + 2;
  else h = (r - g) / delta + 4;

  h = Math.round(h * 60);

  if (h < 0) h += 360;

  l = (cmax + cmin) / 2;
  s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);
  let colorString = "hsl(" + h + "," + s + "%," + l + "%)";
  let returnHSLObject = { h: h, s: s, l: l, HSLcolorString: colorString };
  return returnHSLObject;
}

// R G B to HEX
export function RGBToHex(r, g, b) {
  r = r.toString(16);
  g = g.toString(16);
  b = b.toString(16);

  if (r.length == 1) r = "0" + r;
  if (g.length == 1) g = "0" + g;
  if (b.length == 1) b = "0" + b;

  return "#" + r + g + b;
}

// RGB in string , to HEX
export function RGBAStringToHex(rgba) {
  rgba = rgba.match(
    /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i
  );
  return rgba && rgba.length === 4
    ? "#" +
    ("0" + parseInt(rgba[1], 10).toString(16)).slice(-2) +
    ("0" + parseInt(rgba[2], 10).toString(16)).slice(-2) +
    ("0" + parseInt(rgba[3], 10).toString(16)).slice(-2)
    : "";
}

export function RGBAToHexA(r, g, b, a) {
  r = r.toString(16);
  g = g.toString(16);
  b = b.toString(16);
  a = Math.round(a * 255).toString(16);

  if (r.length == 1) r = "0" + r;
  if (g.length == 1) g = "0" + g;
  if (b.length == 1) b = "0" + b;
  if (a.length == 1) a = "0" + a;

  return "#" + r + g + b + a;
}

// GRADIENT HELPERS
export function parseGradient(grad) {
  const obj = gradient.parse(grad);
  let newObj = JSON.parse(obj);
  let gradientArray = [...newObj.stops.map((stop) => stop.reverse())];
  gradientArray.forEach((stop) => {
    stop[0] = stop[0].replace(/% ?/g, "");
    stop[0] = Number(stop[0]);
    stop[1] = stop[1].match(/[.\d]+/g);
  });
  // clean up the gradient // if it doesn't start at zero or end at 100 we need to generate stops for those.
  let cleanedGradientArray = cleanGradientArray(gradientArray);
  return cleanedGradientArray;
}

function cleanGradientArray(gradientArray) {
  let cleanArray = [...gradientArray];
  if (cleanArray[0][0] !== 0) {
    let stopToAdd = [0, cleanArray[0][1]];
    cleanArray.unshift(stopToAdd);
  }
  if (cleanArray[cleanArray.length - 1][0] !== 100) {
    let stopToAdd = [100, cleanArray[cleanArray.length - 1][1]];
    cleanArray.push(stopToAdd);
  }

  return cleanArray;
}

export function getItemPositionArray(selection) {
  let newSelection = selection.filter((item) => (item.type = "shape"));
  const itemCount = newSelection.length;
  //start at position 1
  let itemPositionArray = [1];
  for (let i = 1; i <= itemCount - 2; i++) {
    // we have 1 less divisional steps now, and therefore we divide by count+1, we also correct forward for starting off of 1 not zero
    let newStop = (100 / (itemCount - 1)) * i;
    itemPositionArray.push(newStop);
  }
  // end at position 100
  itemPositionArray.push(100);
  return itemPositionArray;
}

export function getColorFromGradientWithPercentPosition(grad, position) {
  let colorRange = [];
  grad.every((stop, index) => {
    if (position <= stop[0]) {
      colorRange = [index - 1, index];
      // SOLVE MAYBE HERE
      return false;
    }
    return true;
  });

  //Get the two closest colors

  var firstcolor = grad[colorRange[0]][1];
  var secondcolor = grad[colorRange[1]][1];
  var firstcolor_x = grad[colorRange[0]][0];
  var secondcolor_x = grad[colorRange[1]][0] - firstcolor_x;
  var slider_x = position - firstcolor_x;
  var ratio = slider_x / secondcolor_x;
  var result = pickHex(secondcolor, firstcolor, ratio);
  return result;
}

export function pickHex(color1, color2, weight) {
  var p = weight;
  var w = p * 2 - 1;
  var w1 = (w / 1 + 1) / 2;
  var w2 = 1 - w1;
  var rgba = [
    Math.round(color1[0] * w1 + color2[0] * w2),
    Math.round(color1[1] * w1 + color2[1] * w2),
    Math.round(color1[2] * w1 + color2[2] * w2),
    Math.round(color1[3] * w1 + color2[3] * w2),
  ];
  return rgba;
}

export function hexToRGB(h) {
  let r = 0,
    g = 0,
    b = 0;

  // 3 digits
  if (h.length == 4) {
    r = "0x" + h[1] + h[1];
    g = "0x" + h[2] + h[2];
    b = "0x" + h[3] + h[3];

    // 6 digits
  } else if (h.length == 7) {
    r = "0x" + h[1] + h[2];
    g = "0x" + h[3] + h[4];
    b = "0x" + h[5] + h[6];
  }

  return "rgb(" + +r + "," + +g + "," + +b + ")";
}
